import { Injectable } from '@angular/core';

import { TabsGroupSizesType } from '@frontend/ui/tabsgroup';
import { BehaviorSubject, Observable } from 'rxjs';

import { SubNavigationItem } from './sub-navigation.models';

@Injectable({ providedIn: 'root' })
export class SubNavigationService {
    private _tabs$ = new BehaviorSubject<SubNavigationItem[]>([]);
    private _fullWidth$ = new BehaviorSubject<boolean>(false);
    private _tabSize$ = new BehaviorSubject<TabsGroupSizesType>('large');

    get tabs$(): Observable<SubNavigationItem[]> {
        return this._tabs$.asObservable();
    }

    get tabSize$(): Observable<TabsGroupSizesType> {
        return this._tabSize$.asObservable();
    }

    get fullWidth$(): Observable<boolean> {
        return this._fullWidth$.asObservable();
    }

    setTabs(items: SubNavigationItem[]): void {
        this._tabs$.next(items);
    }

    setTabSize(tabSize: TabsGroupSizesType): void {
        this._tabSize$.next(tabSize);
    }

    setFullWith(fullWidth: boolean): void {
        this._fullWidth$.next(fullWidth);
    }
}
